import React, { useEffect, useState, useRef } from 'react';
import Tabs from '../../../Tabs/Tabs';
import './StudentInfo.scss';
import GralData from './GralData';
import Academic from './Academic';
// import InputAnimated from '../../../inputAnimated';
import CloseSVG from '../../../icons/close';
import InputAutoComplete from '../../../autocomplete/autocomplete';
import Select from '../../../select/select';
import { GetStudentListBySubsidiaryOrNull } from '../../../../utils/Apis/apis';
//navigate
import { useNavigate } from "react-router-dom";
const StudentInfo = ({ onClose, list, usr }) => {
  // Estado para almacenar los alumnos obtenidos desde la API
  const [alumnos, setAlumnos] = useState([]);
  const [selectedAlumno, setSelectedAlumno] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [subsidiaryList, setSubsidiaryList] = useState([])
  const [selectedSubsidiary, setSelectedSubsidiary] = useState('')
  const [selectedStatus, setSelectedStatus] = useState(1)
  const [activeTab, setActiveTab] = useState(0);
  const classCacheAcademic = useRef({});
  const studentCache = useRef({});
  const receptionCache = useRef({})
  const navigate = useNavigate();
  const statusOptions = [
    {
      value: 0,
      label: 'Inactivos',
    },
    {
      value: 1,
      label: 'Activos'
    }
  ]
  useEffect(() => {
    setSubsidiaryList(list.subsidiaryList);
  }, [])

  const lastFetchedSubsidiary = useRef(null);

  useEffect(() => {
    if (!selectedSubsidiary) return;

    const cacheKey = `${selectedSubsidiary}-${selectedStatus}`;

    if (studentCache.current[cacheKey]) {
      setAlumnos(studentCache.current[cacheKey]);
      lastFetchedSubsidiary.current = selectedSubsidiary;
      return;
    }

    const controller = new AbortController();
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const studentListResponse = await GetStudentListBySubsidiaryOrNull(selectedSubsidiary, selectedStatus);

        if (controller.signal.aborted) return;

        if (studentListResponse.auth === false) {
          navigate("/login");
          return;
        }
        studentCache.current[cacheKey] = studentListResponse.result;
        setAlumnos(studentListResponse.result);
        lastFetchedSubsidiary.current = selectedSubsidiary;
      } catch (err) {
        if (!controller.signal.aborted) {
          setError("Error al cargar los alumnos");
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [selectedSubsidiary, selectedStatus]);



  useEffect(() => {
    setActiveTab(0);
  }, [selectedAlumno]);

  // 👇 NUEVO useEffect para sincronizar selectedAlumno después de editar
  useEffect(() => {
    if (selectedAlumno && alumnos.length > 0) {
      const updatedAlumno = alumnos.find(a => a.student.id === selectedAlumno.student.id);
      if (updatedAlumno) {
        setSelectedAlumno(updatedAlumno);
        // ✅ Actualizar caché con alumnos editados
        studentCache.current[selectedSubsidiary] = alumnos;
      }
    }
  }, [alumnos]);

  const handleRefresh = async () => {
    if (!selectedSubsidiary) return;
    setLoading(true);
    setError(null);

    try {
      const studentListResponse = await GetStudentListBySubsidiaryOrNull(selectedSubsidiary, selectedStatus); // 👈 se agrega selectedStatus

      if (studentListResponse.auth === false) {
        navigate("/login");
        return;
      }

      // ✅ Guardar en caché con clave combinada de sucursal + status
      const cacheKey = `${selectedSubsidiary}-${selectedStatus}`;
      studentCache.current[cacheKey] = studentListResponse.result;

      setAlumnos(studentListResponse.result);
      lastFetchedSubsidiary.current = selectedSubsidiary;
    } catch (err) {
      setError("Error al recargar los alumnos");
    } finally {
      setLoading(false);
    }
  };



  const handleSubsidiarySelected = (value) => {
    setSelectedAlumno(null)
    setSelectedSubsidiary(value);

  }
  const handleStatusSelected = (value) => {
    setSelectedAlumno(null)
    setSelectedStatus(value)

  }

  // Función para construir el nombre completo
  const getFullName = (alumno) => {
    return `${alumno.student.name} ${alumno.student.middle_name} ${alumno.student.last_name}`;
  };
  const tabData = [
    {
      label: 'Datos Generales',
      content: <GralData list={list} studentSelected={selectedAlumno} navigate={navigate} usr={usr} subsidiarySelected={selectedSubsidiary} refreshStudents={handleRefresh} receptionistCache={receptionCache}/>,
      disabled: selectedAlumno ? false : true,
    },
    {
      label: 'Académico',
      content: <Academic listClasses={list.allTeacherClassesList} subsidiaryList={list.subsidiaryList} studentSelected={selectedAlumno} classCache={classCacheAcademic}/>,
      disabled: selectedAlumno ? false : true,

    },
    {
      label: 'Pagos',
      content: <div>Contenido prueba  de la pestaña 3</div>,
      disabled: true,

    },
  ];

  return (
    <div className='student-info'>
      <section className='info-header'>
        <h1>Información del alumno</h1>
        <button onClick={onClose} className="close-button main-color">
          <CloseSVG className="main-color" />
        </button>
      </section>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <span>Cargando alumnos...</span>
        </div>
      ) : (
        <>
          <section className='info-searching'>
            <Select
              options={subsidiaryList}
              placeholder={'Selecciona sucursal...'}
              className={'search-box main-color'}
              value={selectedSubsidiary}
              onChange={(e) => handleSubsidiarySelected(e.target.value)}
            />
            <Select
              options={statusOptions}
              placeholder={'Status'}
              className={'search-box main-color'}
              value={selectedStatus}
              onChange={(e) => handleStatusSelected(e.target.value)}

            />
            <InputAutoComplete
              options={alumnos}
              getOptionLabel={(option) => getFullName(option)}
              value={selectedAlumno}
              onChange={(event, newValue) => setSelectedAlumno(newValue)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              className={'search-box main-color'}
              placeholder={"Buscar Alumno..."}
            />
          </section>
          <section className='info-contain'>
            <Tabs tabs={tabData} activeTab={activeTab} setActiveTab={setActiveTab} />
          </section>
        </>
      )}
    </div>
  );
};

export default StudentInfo;
